<p-tabView *ngIf="api.adminUser.value" [(activeIndex)]="tabIndex">
    <p-tabPanel header="Réseaux" >
    		<app-networks></app-networks>
    </p-tabPanel>
    <p-tabPanel header="Conditions">
    	<app-conditions *ngIf="tabIndex === 1"></app-conditions>
    </p-tabPanel>
    <p-tabPanel header="Jeux">
        <app-admin-games *ngIf="tabIndex === 2"></app-admin-games>
    </p-tabPanel>

    <p-tabPanel header="Suivi ouvertures">
        <app-open *ngIf="tabIndex === 3"></app-open>
    </p-tabPanel>
    <p-tabPanel header="Catalogues PDF">
        <app-admin-catalogue *ngIf="tabIndex === 4"></app-admin-catalogue>
    </p-tabPanel>
</p-tabView>